export const MUNDELY_PRICING_EUR_CENTS = Object.freeze({ free:0, monthly:299, annual:1999 });
export function mundelyPlanPrice(period:keyof typeof MUNDELY_PRICING_EUR_CENTS,language:string):string {
  return new Intl.NumberFormat(language,{style:"currency",currency:"EUR",minimumFractionDigits:period==="free"?0:2,maximumFractionDigits:period==="free"?0:2}).format(MUNDELY_PRICING_EUR_CENTS[period]/100);
}
